export const selectRapidTest = (state) => state.rapidTest.rapidTest;
export const selectRapidTestLoading = (state) => state.rapidTest.rapidTestLoading;
export const selectRapidImage = (state) => state.rapidTest.rapidImage;
export const selectRapidImageLoading = (state) => state.rapidTest.rapidImageLoading;
export const selectRapidMembrane = (state) => state.rapidTest.rapidMembrane;
export const selectRapidMembraneLoading = (state) => state.rapidTest.rapidMembraneLoading;
export const selectRapidKit = (state) => state.rapidTest.rapidKit;
export const selectRapidKitLoading = (state) => state.rapidTest.rapidKitLoading;
